if (typeof Array.prototype.at !== "function") {
    // eslint-disable-next-line no-extend-native
    Array.prototype.at = function(index) {
        if (index < 0) {
            index = this.length + index;
        }
        return this[index];
    };
}
